import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { resolveLoyaltyCreditCardFeatureFlag } from 'loyalty/lib/loyaltyCreditCard/resolveLoyaltyCreditCardFeatureFlag'
import { useAppSelector } from 'hooks/reduxHooks'

export function useLoyaltyCreditCardFeatureFlag() {
  const flag = useLabFeatureFlag(LabFeatureFlags.societeCreditCardFlag)
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(() => resolveLoyaltyCreditCardFeatureFlag(flag, currentRegionCode), [flag, currentRegionCode])
}
